import { onMounted, onBeforeUnmount, watch } from "vue";

// Observes `sentinelRef` (a template ref on a marker element at the end of a
// list) and calls `loadMore` once it scrolls into view. Caller is responsible
// for guarding against concurrent/duplicate calls (e.g. an isLoadingMore flag).
export function useInfiniteScroll(sentinelRef, loadMore, options = {}) {
  let observer = null;

  function teardown() {
    observer?.disconnect();
    observer = null;
  }

  function setup() {
    teardown();
    if (!sentinelRef.value) return;
    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) loadMore();
      },
      { root: options.root ?? null, rootMargin: options.rootMargin ?? "200px" }
    );
    observer.observe(sentinelRef.value);
  }

  onMounted(setup);
  onBeforeUnmount(teardown);
  watch(sentinelRef, setup);
}
